var map = {
	"./navigation.de-CH.json": 1011,
	"./navigation.de-DE.json": 1012,
	"./navigation.en-CA.json": 1013,
	"./navigation.en-GB.json": 1014,
	"./navigation.en-IN.json": 1015,
	"./navigation.en-ME.json": 1016,
	"./navigation.en-US.json": 1017,
	"./navigation.es-EM.json": 1018,
	"./navigation.es-ES.json": 1019,
	"./navigation.fr-BE.json": 1020,
	"./navigation.fr-CA.json": 1021,
	"./navigation.fr-CH.json": 1022,
	"./navigation.nl-BE.json": 1023,
	"./navigation.nl-NL.json": 1024,
	"./navigation.pl-PL.json": 1025,
	"./navigation.pt-BR.json": 1026
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1010;